import { Navigate, Outlet } from "react-router-dom";
import { getToken, getUser } from "../../utils/Storage";

const PrivateRoutes = ({ allowedRoles }) => {
  const token = getToken();
  const user = getUser();

  // If no token → go login
  if (!token) {
    return <Navigate to="/login" replace />;
  }

  // If role not allowed → block
  if (
    allowedRoles &&
    (!user || !allowedRoles.includes(user.role))
  ) {
    return <Navigate to="/login" replace />;
  }

  return <Outlet />;
};

export default PrivateRoutes;
